module.exports = __webpack_public_path__ + "static/media/CG-Plag查重系统使用说明.daa287ce.pdf";